/**
 * `.fx` scroll-triggered fade-in animation + video slow-down.
 * Port 1:1 din legacy common.js lines 2410-2460.
 *
 * Adauga .fx-done pe elementele cu .fx cand intra in viewport. Curatare
 * dupa marcare (splice din array). Recheck pe scroll/resize.
 */

import { $ } from '../core/selector.js';

export function initFx(): void {
    const fxNodeList = $('.fx', true);
    if (!fxNodeList.length) return;

    const fxElements: Element[] = [];
    fxNodeList.forEach((target) => fxElements.push(target));

    let fxBusy = false;

    function fxCheck(): void {
        if (fxBusy) return;
        fxBusy = true;
        if (fxElements.length === 0) {
            fxBusy = false;
            return;
        }
        const wh = window.innerHeight;
        let i = fxElements.length;
        while (i--) {
            const r = fxElements[i]!.getBoundingClientRect();
            const t = r.top;
            const b = r.bottom;
            if ((t < wh && t > 0) || (b < wh && b > 0)) {
                fxElements[i]!.classList.add('fx-done');
                fxElements.splice(i, 1);
            }
        }
        setTimeout(() => { fxBusy = false; }, 80);
    }

    fxCheck();
    setTimeout(fxCheck, 200);
    setTimeout(fxCheck, 600);
    setTimeout(fxCheck, 1000);

    window.addEventListener('resize', fxCheck);
    window.addEventListener('scroll', fxCheck);
}

/** Reduce playbackRate pe toate <video> la 0.7 (hero looped videos). */
export function initVideoSlowdown(): void {
    $('video', (video) => {
        (video as HTMLVideoElement).playbackRate = 0.7;
        return true;
    });
}
